import React, { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import MyDatePicker from "../../atoms/Common/MyDatePicker";

export default function PaymentTxExportLayoutForm({ onExport }) {
  const [paymentDate, setPaymentDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const isValid = Boolean(paymentDate) && paymentDate.isValid();

  const handleExport = async () => {
    if (!isValid || loading) return;
    try {
      setLoading(true);
      await onExport(paymentDate);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={1}>
      <Stack spacing={3}>
        <Typography variant="body2" color="text.secondary">
          Se exportarán todas las transacciones de pago con la fecha seleccionada.
        </Typography>
        <MyDatePicker
          label="Fecha de pago"
          value={paymentDate}
          onChange={(value) => setPaymentDate(value)}
          slotProps={{ textField: { fullWidth: true } }}
        />
        <Stack direction="row" justifyContent="flex-end">
          <Button variant="contained" onClick={handleExport} disabled={!isValid || loading}>
            {loading ? "Exportando..." : "Exportar"}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
